export default "__VITE_ASSET__UC0YuOEW__"